import { Module } from 'vuex';

import { MINUTE } from 'frontend/constants';
import { ExportData, RootState } from 'frontend/types';
import { getJson } from 'frontend/utils/ajax';

const exportData: Module<ExportData, RootState> = {
  namespaced: true,
  state: () => ({
    state: undefined,
    signed_url: undefined,
    started_time: undefined,
    user: undefined,
    token: undefined,
  }),
  mutations: {
    setValue(state, value: ExportData): void {
      Object.assign(state, value);
    },
  },
  actions: {
    startExporting({ commit, state, dispatch }) {
      getJson('/account/settings/data-portal/start-personal-data-export/').then(responseJson => {
        commit('setValue', responseJson.export_data);
        if (state.state === 'exporting') {
          setTimeout(() => dispatch('checkExportState'), MINUTE);
        }
      });
    },
    checkExportState({ commit, state, dispatch }) {
      getJson('/account/settings/data-portal/personal-data-export-state/').then(responseJson => {
        commit('setValue', responseJson.export_data);
        if (state.state === 'exporting') {
          setTimeout(() => dispatch('checkExportState'), MINUTE);
        }
      });
    },
  },
  getters: {
    exportState(state: ExportData): string | undefined {
      return state.state;
    },
    startedTime(state: ExportData): string | undefined {
      return state.started_time;
    },
  },
};

export default exportData;
